import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";

function HomeButton({text="Home"}) {
    const navigate = useNavigate()
    const eventName = sessionStorage.getItem("eventName")
  return (
    <p
    className="d-flex float-end"
      onClick={() => navigate(`/events/${eventName}`)}
      style={{cursor: 'pointer', justifyContent: 'center', alignItems: 'center'}}
    >
      <ArrowBackIcon sx={{ fontSize: 16, margin: 'auto' }} />{" "} {text} 
    </p>
  )
}

export default HomeButton
